<template>
  <div>
    <v-alert v-if="!adminlogado" type="warning" outlined dense class="mb-4">
      Acesso restrito: faça login como administrador para editar questionário.
    </v-alert>
    <v-container v-else>
      <v-card class="mt-6" elevation="2">
        <v-card-title class="font-weight-bold d-flex align-center">
          <v-btn
            outlined
            color="grey lighten-1"
            class="mr-4"
            @click="voltarConfigurarQuestionario"
            title="Voltar para configuração de questionário"
          >
            <v-icon size="20">mdi-arrow-left</v-icon>
            <span class="ml-2" style="font-size: 10px">Voltar</span>
          </v-btn>
          Editar Questionário
        </v-card-title>
        <v-card-text>
          <div>
            <template v-if="questionarioSelecionado">
              <p><strong>ID:</strong> {{ questionarioSelecionado.id }}</p>
            </template>
            <v-text-field v-model="instrumento" label="Instrumento" outlined class="mb-3"></v-text-field>
            <v-text-field v-model="anexo" label="Anexo" outlined class="mb-3"></v-text-field>
            <v-text-field
              v-model="ano"
              label="Ano"
              type="number"
              outlined
              class="mb-3"
              @input="atualizarAnoStore"
            ></v-text-field>
            <v-select
              v-model="statusSelecionado"
              :items="statusOptions"
              label="Status"
              outlined
              class="mb-3"
            ></v-select>
            <v-select
              v-model="idPublicoSelecionado"
              :items="publicosOptions"
              item-text="descricao"
              item-value="id"
              label="Público"
              outlined
              class="mb-3"
              :loading="loadingPublicos"
            ></v-select>
            <v-text-field
              v-model="grupoResposta"
              label="Grupo Resposta"
              type="number"
              outlined
              class="mb-3"
              append-icon="mdi-magnify"
              @click:append="abrirModalGrupos"
              readonly
            ></v-text-field>
            <v-btn
              color="success"
              class="mt-4 mx-2"
              style="min-width: 180px"
              @click="salvarQuestionario"
              :disabled="!formValido"
            >
              {{ questionarioSelecionado && questionarioSelecionado.id ? "Salvar Alterações" : "Criar Questionário" }}
            </v-btn>
            <v-btn
              v-if="questionarioSelecionado && questionarioSelecionado.id"
              color="info"
              class="mt-2 mx-2"
              style="min-width: 180px"
              @click="configurarQuestoes"
            >
              Configurar Questões
            </v-btn>
            <v-btn
              v-if="questionarioSelecionado && questionarioSelecionado.id"
              color="primary"
              class="mt-2 mx-2"
              style="min-width: 180px"
              @click="carregarQuestoes"
            >
              Carregar Questões
            </v-btn>
            <div v-if="questionarioSelecionado && questionarioSelecionado.id" class="mt-4">
              <v-card outlined class="mb-2">
                <v-card-title class="subtitle-1 font-weight-bold">Questões do Questionário</v-card-title>
                <v-divider></v-divider>
                <v-list dense v-if="questoes.length">
                  <v-list-item v-for="q in questoes" :key="q.id">
                    <v-list-item-content>
                      <v-list-item-title v-html="q.descricao || q.titulo || 'Sem título'"></v-list-item-title>
                      <v-list-item-subtitle>Ordem: {{ q.ordem }}</v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-btn icon small color="primary" @click="abrirModalQuestao(q)"
                        ><v-icon>mdi-pencil</v-icon></v-btn
                      >
                      <v-btn icon small color="error" @click="excluirQuestao(q)"><v-icon>mdi-delete</v-icon></v-btn>
                    </v-list-item-action>
                  </v-list-item>
                </v-list>
                <div v-else class="text-center py-4 grey--text">Nenhuma questão cadastrada ainda.</div>
                <v-card-actions>
                  <v-btn color="success" @click="abrirModalQuestao()">Inserir Nova Questão</v-btn>
                </v-card-actions>
              </v-card>
            </div>
            <v-dialog v-model="modalQuestao" max-width="500px">
              <v-card>
                <v-card-title class="headline">{{
                  questaoEditando.id ? "Editar Questão" : "Nova Questão"
                }}</v-card-title>
                <v-card-text>
                  <v-text-field
                    v-model="questaoEditando.ordem"
                    label="Ordem"
                    outlined
                    class="mb-3"
                    type="number"
                    :min="1"
                    :max="maxOrdem"
                  />
                  <quill-editor
                    v-model="questaoEditando.descricao"
                    :options="editorOptions"
                    class="mb-3"
                  ></quill-editor>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" @click="salvarQuestao">Salvar</v-btn>
                  <v-btn text @click="fecharModalQuestao">Cancelar</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-btn
              v-if="questionarioSelecionado && questionarioSelecionado.id"
              color="error"
              class="mt-2 mx-2"
              style="min-width: 180px"
              @click="excluirQuestionario"
            >
              Excluir Questionário
            </v-btn>
            <v-dialog v-model="modalGrupos" max-width="600px">
              <v-card>
                <v-card-title class="headline">Selecione o Grupo de Resposta</v-card-title>
                <v-card-text>
                  <div v-if="loadingGrupos" class="text-center">
                    <v-progress-circular indeterminate color="primary"></v-progress-circular>
                  </div>
                  <div v-else>
                    <v-row>
                      <v-col v-for="(grupo, idx) in gruposOpcoes" :key="idx" cols="12" md="6">
                        <v-card outlined @click="selecionarGrupo(grupo.grupo)" class="mb-2" style="cursor: pointer">
                          <v-card-title>Grupo {{ grupo.grupo }}</v-card-title>
                          <v-card-text>
                            <v-list dense>
                              <v-list-item v-for="opcao in grupo.opcoes" :key="opcao.ordem">
                                <v-list-item-content>
                                  <v-list-item-title>{{ opcao.descricao }}</v-list-item-title>
                                </v-list-item-content>
                                <v-list-item-action>
                                  <span class="grey--text">Valor: {{ opcao.valor }}</span>
                                </v-list-item-action>
                              </v-list-item>
                            </v-list>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                  </div>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="modalGrupos = false">Fechar</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog v-model="loading" persistent max-width="300">
              <v-card color="primary" dark>
                <v-card-text class="text-center">
                  <v-progress-circular indeterminate color="white"></v-progress-circular>
                  <div class="mt-3">Processando...</div>
                </v-card-text>
              </v-card>
            </v-dialog>
          </div>
        </v-card-text>
      </v-card>
    </v-container>
    <v-dialog v-model="loading" persistent max-width="300">
      <v-card color="primary" dark>
        <v-card-text class="text-center">
          <v-progress-circular indeterminate color="white"></v-progress-circular>
          <div class="mt-3">Processando...</div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar" :color="snackbarColor" timeout="3500" top>
      {{ snackbarText }}
    </v-snackbar>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";
export default {
  name: "EditarQuestionario",
  // QuillEditor agora é global via Vue.use(VueQuillEditor)
  computed: {
    ...mapState({ adminlogado: (state) => state.avaliacao.adminlogado }),
    ...mapGetters({ questionarioSelecionado: "avaliacao/selecionado" }),
    ...mapGetters({ questionarioSelecionado: "avaliacao/selecionado" }),
    formValido() {
      return (
        this.instrumento.trim() !== "" &&
        this.anexo.trim() !== "" &&
        this.ano !== null &&
        this.ano !== "" &&
        this.statusSelecionado !== null &&
        this.idPublicoSelecionado !== null &&
        this.grupoResposta !== null &&
        this.grupoResposta !== ""
      );
    },
  },
  data() {
    return {
      statusOptions: [
        { text: "Sim", value: 1 },
        { text: "Não", value: 0 },
      ],
      statusSelecionado: 0,
      publicosOptions: [],
      idPublicoSelecionado: null,
      loadingPublicos: false,
      instrumento: "",
      anexo: "",
      ano: "",
      grupoResposta: "",
      modalGrupos: false,
      loadingGrupos: false,
      gruposOpcoes: [],
      loading: false,
      snackbar: false,
      snackbarText: "",
      snackbarColor: "success",
      questoes: [],
      modalQuestao: false,
      questaoEditando: { id: null, ordem: 1, descricao: "" },
      editorOptions: { theme: "snow", placeholder: "Digite a descrição da questão..." },
      maxOrdem: 100,
    };
  },
  watch: {
    questionarioSelecionado: {
      handler(val) {
        this.instrumento = val.instrumento || "";
        this.anexo = val.anexo || "";
        this.ano = val.ano || "";
        this.statusSelecionado = val.status !== undefined ? Number(val.status) : 0;
        this.idPublicoSelecionado = val.id_publico !== undefined ? Number(val.id_publico) : null;
        this.grupoResposta = val.grupo_resposta || "";
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    ...mapActions({
      requestPublicoQuestionarioAll: "avaliacao/requestPublicoQuestionarioAll",
      requestOpcoes: "avaliacao/requestOpcoes",
      atualizarQuestao: "avaliacao/atualizarQuestao",
      criarQuestao: "avaliacao/criarQuestao",
      deletarQuestao: "avaliacao/deletarQuestao",
      requestQuestao: "avaliacao/requestQuestao",
      atualizarQuestionario: "avaliacao/atualizarQuestionario",
      criarQuestionario: "avaliacao/criarQuestionario",
      deletarQuestionario: "avaliacao/deletarQuestionario",
    }),
    ...mapMutations({
      setAnoSelecionado: "avaliacao/setAnoSelecionado",
      setSelecionado: "avaliacao/setSelecionado",
    }),
    atualizarAnoStore() {
      this.setAnoSelecionado(this.ano);
    },
    voltarConfigurarQuestionario() {
      // Garante que o ano e o questionário selecionado permaneçam na store
      this.setSelecionado(this.questionarioSelecionado);
      this.setAnoSelecionado(this.ano);
      this.$router.push({ name: "ConfigurarQuestionario" });
    },
    configurarQuestoes() {
      // Salva o questionário selecionado na store
      this.setSelecionado(this.questionarioSelecionado);
      this.setAnoSelecionado(this.ano);
      // this.$router.push({ name: 'ConfigurarQuestoes' });
    },
    async carregarPublicos() {
      this.loadingPublicos = true;
      try {
        const { data } = await this.requestPublicoQuestionarioAll();
        this.publicosOptions = Array.isArray(data) ? data.map((p) => ({ ...p, id: Number(p.id) })) : [];
        if (this.questionario) {
          this.idPublicoSelecionado = Number(this.questionario.id_publico);
        }
      } catch (e) {
        this.publicosOptions = [];
      }
      this.loadingPublicos = false;
    },
    async abrirModalGrupos() {
      this.modalGrupos = true;
      this.loadingGrupos = true;
      try {
        // Requisição para /opcoes via Vuex
        const resp = await this.requestOpcoes({});
        const data = resp.data;
        // Agrupa por grupo
        const grupos = {};
        data.forEach((op) => {
          if (!grupos[op.grupo]) grupos[op.grupo] = [];
          grupos[op.grupo].push(op);
        });
        // Transforma em array de grupos
        this.gruposOpcoes = Object.keys(grupos).map((grupo) => ({
          grupo,
          opcoes: grupos[grupo],
        }));
      } catch (e) {
        this.gruposOpcoes = [];
      }
      this.loadingGrupos = false;
    },
    selecionarGrupo(grupo) {
      this.grupoResposta = grupo;
      this.modalGrupos = false;
    },
    abrirModalQuestao(questao = null) {
      if (questao) {
        this.questaoEditando = { ...questao };
      } else {
        // Sugerir próxima ordem
        const ordens = this.questoes.map((q) => Number(q.ordem));
        let nextOrdem = 1;
        while (ordens.includes(nextOrdem)) nextOrdem++;
        this.questaoEditando = { id: null, ordem: nextOrdem, descricao: "" };
      }
      this.modalQuestao = true;
    },
    fecharModalQuestao() {
      this.modalQuestao = false;
    },
    async salvarQuestao() {
      this.loading = true;
      // Validação: ordem única
      const ordens = this.questoes.filter((q) => q.id !== this.questaoEditando.id).map((q) => Number(q.ordem));
      if (ordens.includes(Number(this.questaoEditando.ordem))) {
        this.snackbarText = "Já existe uma questão com essa ordem!";
        this.snackbarColor = "error";
        this.snackbar = true;
        this.loading = false;
        return;
      }
      try {
        if (this.questaoEditando.id) {
          // Editar questão
          await this.atualizarQuestao({
            id: this.questaoEditando.id,
            id_questionario: this.questionarioSelecionado.id,
            ordem: Number(this.questaoEditando.ordem),
            descricao: this.questaoEditando.descricao,
          });
          this.snackbarText = "Questão atualizada com sucesso!";
          this.snackbarColor = "success";
          this.carregarQuestoes();
        } else {
          // Inserir nova questão

          await this.criarQuestao({
            id_questionario: this.questionarioSelecionado.id,
            ordem: Number(this.questaoEditando.ordem),
            descricao: this.questaoEditando.descricao,
          });

          this.snackbarText = "Questão criada com sucesso!";
          this.snackbarColor = "success";
          this.carregarQuestoes();
        }
      } catch (e) {
        console.error("Erro ao salvar questão:", e);
        this.snackbarText = `Erro ao salvar questão: ${e?.message || e}`;
        this.snackbarColor = "error";
      }
      this.snackbar = true;
      this.loading = false;
      this.fecharModalQuestao();
    },
    // Removido duplicidade
    async excluirQuestao(questao) {
      if (!questao || !questao.id) return;
      this.loading = true;
      try {
        await this.deletarQuestao(questao.id);
        this.snackbarText = "Questão excluída com sucesso!";
        this.snackbarColor = "success";
        this.carregarQuestoes();
      } catch (e) {
        this.snackbarText = "Erro ao excluir questão.";
        this.snackbarColor = "error";
      }
      this.snackbar = true;
      this.loading = false;
    },
    async carregarQuestoes() {
      if (!this.questionarioSelecionado || !this.questionarioSelecionado.id) return;
      this.loading = true;
      try {
        const resp = await this.requestQuestao({ id_questionario: this.questionarioSelecionado.id });
        this.questoes = Array.isArray(resp?.data[0]) ? resp.data[0] : [];
        if (!this.questoes.length) {
          this.snackbarText = "Nenhuma questão encontrada para este questionário.";
          this.snackbarColor = "info";
          this.snackbar = true;
        }
      } catch (e) {
        this.snackbarText = "Erro ao carregar questões.";
        this.snackbarColor = "error";
        this.snackbar = true;
        this.questoes = [];
      }
      this.loading = false;
    },
    async salvarQuestionario() {
      this.loading = true;

      const payload = {
        id: this.questionarioSelecionado.id,
        instrumento: this.instrumento,
        anexo: this.anexo,
        ano: this.ano,
        status: this.statusSelecionado,
        id_publico: this.idPublicoSelecionado,
        grupo_resposta: this.grupoResposta,
      };

      try {
        if (this.questionarioSelecionado && this.questionarioSelecionado.id) {
          await this.atualizarQuestionario(payload);

          this.snackbarText = "Questionário atualizado com sucesso!";
          this.snackbarColor = "success";
        } else {
          await this.criarQuestionario(payload);
          this.snackbarText = "Questionário criado com sucesso!";
          this.snackbarColor = "success";
        }
      } catch (e) {
        this.snackbarText = "Erro ao salvar questionário";
        this.snackbarColor = "error";
      }
      this.snackbar = true;
      this.loading = false;
    },
    async excluirQuestionario() {
      this.loading = true;
      if (this.questionario && this.questionario.id) {
        try {
          await this.deletarQuestionario(this.questionario.id);
          this.snackbarText = "Questionário excluído com sucesso!";
          this.snackbarColor = "success";
        } catch (e) {
          this.snackbarText = "Erro ao excluir questionário";
          this.snackbarColor = "error";
        }
      }
      this.snackbar = true;
      this.loading = false;
    },
  },
  mounted() {
    this.carregarPublicos();
    this.carregarQuestoes();
  },
};
</script>

<style scoped></style>
